import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 储存渠道数据，新增渠道都需要在这里添加相关信息
const totalChannels = {
  // 子渠道作为标识
  virtual_account: {
    name: '銀行匯款', // 页面上显示的渠道文案
    isBank: true
  },
  mycard_ingame_tw: {
    name: '台灣點卡',
    isPoints: true
  },
  mycard_ingame_os: {
    name: '海外點卡',
    isPoints: true
  },
  mycard_webatm: {
    name: 'Web-ATM',
    needDetail: true,
    catalog: 'webatm'
  },
  mycard_telephone: {
    name: '手機/市話/寬頻',
    needDetail: true,
    catalog: 'telephone'
  },
  mycard_zfb: {
    name: '支付寶'
  },
  paypal: {
    name: 'PayPal'
  },
  gash: {
    name: 'Gash'
  },
  mycard_member_pay: {
    name: '會員扣點'
  },
  mycard_bdt: {
    name: '八達通'
  },
  mycard_jfl: {
    name: 'PPS繳費靈'
  },
  mol_point: {
    name: 'Razer Pin'
  },
  mol_wallet: {
    name: 'Razer Gold'
  },
  mycard_credit_card: {
    name: '信用卡(3D驗證)',
    needDetail: true,
    catalog: 'credit_card'
  },
  mycard_zgxtds: {
    name: '台灣信用卡'
  },
  mycard_netpay: {
    name: '電子/行動支付'
  },
  cosmopay_visa: {
    name: 'Visa'
  },
  cosmopay_master: {
    name: 'Master'
  },
  'VISA-SSL': {
    name: 'Visa'
  },
  'ECMC-SSL': {
    name: 'Master'
  },
  'paydibs-MYR': {
    name: 'Paydibs'
  },
  'paydibs-SGD': {
    name: 'Paydibs'
  },
  maxis: {
    name: 'maxis'
  },
  mol_fpx: {
    name: 'Bank(FPX)'
  },
  mol_enets: {
    name: 'eNETS'
  },
  // 暫時不開放這兩個渠道
  wechat: {
    name: 'WeChat Pay'
  },
  alipay: {
    name: 'Alipay'
  },
  'HK-WALLET-WECHATPAYHK': {
    name: 'WeChat Pay'
  },
  'HK-WALLET-ALIPAYHK': {
    name: 'Alipay'
  }
}

/**
 * [序列化渠道列表信息]
 * @param  {[Array]} data [渠道列表数据]
 * @param  {[Boolean]} isOpenCoupon [是否开启优惠券]
 * @return {[type]}       [description]
 */
const serialChannel = (data, isOpenCoupon) => {
  let channels = data.reduce((arr, item) => {
    let obj = {
      fid: item[0],
      id: item[1],
      info: totalChannels[item[1]],
      name: (totalChannels[item[1]] || { name: item[1] }).name,
      icon: `//mabres.gm99.com/commonImg/store/${item[0]}/${item[1]}.png`,
      currency: item[2],
      creditCards: item[5]
    }
    if (isOpenCoupon) {
      obj['tips'] = +item[4] ? '贈送抵扣券' : ''
    }
    if (totalChannels[obj.id]) {
      arr.push(obj)
    }
    return arr
  }, [])
  return channels
}

export default new Vuex.Store({
  state: {
    channels: [],
    userInfo: {
      game_id: '',
      server_id: '',
      role_id: '',
      role_name: '',
      UID: '',
      account_name: '',
      avatar: '',
      wallet: 0
    },
    isPortrait: false,
    showTips: false,
    tipsTitle: '系統錯誤',
    tipsConent: '',
    isLoading: false,
    fromPage: '',
    pageName: ''
  },
  getters: {
    getChannels: state => state.channels,
    getUserInfo: state => state.userInfo,
    getDeviceDirection: state => state.isPortrait,
    getShowTips: state => state.showTips,
    getTipsInfo: state => ({
      title: state.tipsTitle,
      content: state.tipsConent
    }),
    getIsLoading: state => state.isLoading,
    getFromPage: state => state.fromPage,
    getPageName: state => state.pageName
  },
  mutations: {
    generateChannels (state, { channels, isOpenCoupon }) {
      state.channels = serialChannel(channels, isOpenCoupon)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setDeviceDirection (state, isPortrait) {
      state.isPortrait = isPortrait
    },
    setTipsState (state, showTips) {
      state.showTips = showTips
    },
    setTipsContent (state, content) {
      state.tipsConent = content
    },
    setLoadingState (state, isLoading) {
      state.isLoading = isLoading
    },
    setPageInfo (state, { fromPage, pageName }) {
      state.fromPage = fromPage
      state.pageName = pageName
    },
    deleteCreditCards(state, payload) {
      for (let i = 0, length = state.channels.length; i < length; i++) {
        if (state.channels[i].id === payload.payType) {
          state.channels[i].creditCards = 
            state.channels[i].creditCards.filter((item) => {
              return item.KEY_VALUE !== payload.keyValue;
            })
          break;
        }
      }
    }
  },
  actions: {}
})
